import { render, staticRenderFns } from "./AddCommentMedia.vue?vue&type=template&id=8a8af374&scoped=true&"
import script from "./AddCommentMedia.vue?vue&type=script&lang=js&"
export * from "./AddCommentMedia.vue?vue&type=script&lang=js&"
import style0 from "./AddCommentMedia.vue?vue&type=style&index=0&id=8a8af374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8af374",
  null
  
)

export default component.exports